import React, { useEffect } from "react";

import { Switch, Route, Redirect } from "react-router-dom";

import { Container } from "@material-ui/core";

import BottomNav from "../../../components/molecules/BottomNav";
import { Katalog, Akun, TokoSaya, Transaksi, Notification } from "..";

import useStyles from "./style";
import { useData } from "../../../components/firebase/DataProvider";
import { firefunctions } from "../../../components/firebase/FirebaseProvider";
import NotifHeader from "../../../components/molecules/NotifHeader";
import AkunNotActive from "../Akun/AkunNotActive";

function LayoutA() {
  const {
    userInpoin,
    profil,
    level,
    webstore,
    subdomain,
    global_settings,
    inpoinActivity,
  } = useData();

  const classes = useStyles();

  useEffect(() => {
    if (
      !userInpoin?.auth &&
      global_settings?.aktivasi_inpoin &&
      level?.is_active
    ) {
      const regisInpoin = async () => {
        try {
          const func = firefunctions.httpsCallable("inpoin-register");
          const data = {};
          await func(data);
        } catch (error) {
          // console.log("error");
        }
      };
      regisInpoin();
    }
  }, [!userInpoin?.auth, global_settings?.aktivasi_inpoin, level?.is_active]);

  if (!profil?.nama) {
    return <Redirect to="/register/form" />;
  } else if (!subdomain || !webstore) {
    return <Redirect to="/register/info" />;

    // } else if (!profil?.alamat_utama) {
    //   return <Redirect to="/register/alamat" />
  } else if (!level?.is_active && !global_settings.aktivasi_register_by_order) {
    return <Redirect to="/register/pembayaran" />;
  } else
    return (
      <Container
        maxWidth="md"
        classes={{ root: classes.container }}
        className={classes.mainContainer}
      >
        <NotifHeader />
        <Switch>
          {level.is_active ? (
            <>
              <Route exact path="/" component={Katalog} />
              <Route path="/notification" component={Notification} />
              <Route
                path="/akun"
                component={level.is_active ? Akun : AkunNotActive}
              />
              <Route path="/tokosaya" component={TokoSaya} />
              <Route path="/transaksi" component={Transaksi} />
            </>
          ) : (
            <>
              <Route exact path="/" component={Katalog} />
              <Route path="/notification" component={Notification} />
              <Route
                path="/akun"
                component={level.is_active ? Akun : AkunNotActive}
              />
              <Route path="/transaksi" component={Transaksi} />
            </>
          )}
        </Switch>

        <BottomNav notActive={level.is_active} />
      </Container>
    );
}

export default LayoutA;
